import React, {useEffect} from 'react';
import { BrowserRouter, Routes, Route, Link, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
// import { AuthRouteWithLayout } from './components';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
  Dashboard as DashboardView,
  SmartCharging as SmartChargingView,
  QRCodeInput as QRCodeInputView,
  QRCodeSamples as QRCodeSamplesView,
  QRCodeMalaysia as QRCodeMalaysiaView,

//   // Typography as TypographyView,

//   // Account as AccountView,

//   // SignIn as SignInView,
//   // NotFound as NotFoundView,

//   // Stations as StationsView,
//   // StationUpdate as StationUpdateView,
//   // StationsAdd as StationsAddView,

//   // Chargers as ChargersView,
//   // ChargerAdd as ChargerAddView,
//   // ChargerUpdate as ChargerUpdateView,

//   // UsagesCharger as UsagesChargerView,
//   // UsagesUser as UsagesUserView,

//   // Installations as InstallationsView,
//   // InstallationAdd as InstallationAddView,
//   // InstallationUpdate as InstallationUpdateView,

//   // Malfunctions as MalfunctionsView,
//   // MalfunctionAdd as MalfunctionAddView,
//   // MalfunctionUpdate as MalfunctionUpdateView,

//   // SalesCharger as SalesChargerView,
//   // SalesUser as SalesUserView,
//   // SalesMember as SalesMemberView,
//   // SalesCardCompany as SalesCardCompanyView,
//   // SalesApprovedDetails as SalesApprovedDetailsView,

//   // Notices as NoticeView,
//   // NoticeAdd as NoticeAddView,
//   // NoticeUpdate as NoticeUpdateView,

//   // Members as MembersView,
//   // MemberAdd as MemberAddView,
//   // MemberUpdate as MemberUpdateView,

//   // Users as UsersView,
//   // UserAdd as UserAddView,
//   // UserUpdate as UserUpdateView,

//   // KepcoUnitPriceUpdate as KepcoUnitPriceUpdateView,
//   // CastproUnitPriceUpdate as CastproUnitPriceUpdateView,
//   // SettingENV as SettingENVView,
//   // ChargerModel as ChargerModelView,
//   // ChargerModelAdd as ChargerModelAddView,
//   // ChargerModelUpdate as ChargerModelUpdateView,

//   // CommandNav as CommandNavView,

//   // BootNotification as BootNotificationView,
//   // ChangeAvailability as ChangeAvailabilityView,
//   // ChangeConfiguration as ChangeConfigurationView,
//   // ClearCache as ClearCacheView,
//   // GetDiagnostics as GetDiagnosticsView,
//   // RemoteStartTransaction as RemoteStartTransactionView,
//   // RemoteStopTransaction as RemoteStopTransactionView,
//   // Reset as ResetView,
//   // UnlockConnector as UnlockConnectorView,
//   // UpdateFirmware as UpdateFirmwareView,

//   // ReserveNow as ReserveNowView,
//   // CancelReservation as CancelReservationView,
//   // DataTransfer as DataTransferView,
//   // GetConfiguration as GetConfigurationView,
//   // GetLocalListVersion as GetLocalListVersionView,
//   // SendLocalList as SendLocalListView,
//   // TriggerMessage as TriggerMessageView,
//   // GetCompositeSchedule as GetCompositeScheduleView,
//   // ClearChargingProfile as ClearChargingProfileView,
//   // SetChargingProfile as SetChargingProfileView,
//   // SignedUpdateFirmware as SignedUpdateFirmwareView,
//   // GetLog as GetLogView,
//   // InstallCertificate as InstallCertificateView,
//   // ExtendedTriggerMessage as ExtendedTriggerMessageView,
//   // CertificateSigned as CertificateSignedView,
//   // DeleteCertificate as DeleteCertificateView,
//   // GetInstalledCertificateIds as GetInstalledCertificateIdsView,

} from './views';


import thunkMiddleware from 'redux-thunk'
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from './reducers'
// import { tempSetUser } from 'actions/user';
// import { doLoginWithPW } from 'common/login';
import { createBrowserHistory, createHashHistory } from 'history'

import i18n from 'i18n/i18n';  // i18n 객체 직접 import
import 'intl-pluralrules';


export const history = createHashHistory()

const browserHistory = createBrowserHistory();

const middleware = applyMiddleware(thunkMiddleware)
const store = createStore(
  reducer,
  composeWithDevTools(middleware)
  );


// const loadUser = () => {
//   const userjson = localStorage.getItem('userinfo');

//   if(!userjson) return;

//   let user = JSON.parse(userjson);
//   store.dispatch(tempSetUser(user));
// }


const AppRouter = (props) => {

  const {className, user, ...rest } = props;


  const changeLanguage = value => {
    i18n
      .changeLanguage(value)
      .then(() => {
        console.log("*********** change language:"+ value );
        // setSelectedLanguage(value);
        localStorage.setItem('locale', value);
      })
      .catch(err => console.log(err));
  };


  useEffect(()=>{

    // loadUser();

    const locale = localStorage.getItem("locale");

    if (locale){
      //있으면
      console.log("/////////// --- " + locale);
      changeLanguage(locale);
    } else {
      //없으면, default로 en 으로 선택한다.
      changeLanguage( "en-US" );
    }

  },[]);



  return (
    <Provider store={store}>
    <div>

    <Routes history={browserHistory}>
      {/* <Route path="/dashboard" element={<DashboardView/>} /> */}
      {/* <RouteWithLayout component={DashboardView} exact layout={MainLayout} path="/dashboard" /> */}


      {/* <RouteWithLayout element={DashboardView} exact layout={MainLayout} path="/dashboard" /> */}
      {/* <Route path="/" element={<DashboardView/>} exact layout={MainLayout} /> */}


      <Route path="/" element={<MainLayout> <DashboardView/> </MainLayout>} />
      <Route path="/smartcharging" element={<MainLayout><SmartChargingView/></MainLayout>} />
      <Route path="/qrcodeinput" element={<MainLayout>< QRCodeInputView/></MainLayout>} />
      <Route path="/qrcodesamples" element={<MainLayout>< QRCodeSamplesView/></MainLayout>} />
      <Route path="/qrcodesMalaysia" element={<MainLayout>< QRCodeMalaysiaView/></MainLayout>} />

    </Routes>

    </div>
    </Provider>
  );
};

export default AppRouter;
